export const COLOR = {
    BG_MAIN_COLOR: "#effafc",
    MAIN_COLOR: "#4267b2",
    CLICK_MENU_COLOR: "#FFAA47",
    NOTIFY_MENU_COLOR: "#E95F5C",
    INSTA_COLOR: "#FF8576",
    VIP: "#4267b2",
    TIKTOK_COLOR: "#1a1a1a",
    YOUTUBE_COLOR: "#ff0000"
};

export const SEEDING = {
    SHARE: 1,
    LIKE: 2,
    COMMENT: 3,
    LIKE_FANPAGE: 4,
    FOLLOW: 5,
    INSTA_LIKE: 6,
    INSTA_FOLLOW: 7,
    INSTA_COMMENT: 8,
    STREAM: 9,
    REVIEW_FANPAGE: 15,
    TIKTOK_LIKE: 16,
    TIKTOK_COMMENT: 17,
    TIKTOK_FOLLOW: 19,
    FACEBOOK_VIEW: 20,
    YOUTUBE_VIEW: 21,
    TIKTOK_VIEW: 22,
    GROUP: 23,
    LIKE_COMMENT: 24,
    GROUP_NO_AVATAR: 31,
};

export const SEEDING_TYPE = {
    ID_FACEBOOK_SHARE_POST: 1,
    ID_FACEBOOK_REACTION_POST: 2,
    ID_FACEBOOK_COMMENT_POST: 3,
    ID_FACEBOOK_REACTION_FANPAGE: 4,
    ID_FACEBOOK_SUB: 5,
    ID_FACEBOOK_BUFF_EYE_STREAM: 14,
    ID_FACEBOOK_BUFF_FANPAGE_REVIEW: 15,
    ID_FACEBOOK_BUFF_MEM_GROUP: 23,
    ID_FACEBOOK_BUFF_LIKE_COMMENT: 24,
    ID_BOT_INTERACTION: 27,
    ID_BOT_SPAM: 28,
    ID_BUY_PROXY: 29,
    ID_FACEBOOK_RIP_ACCOUNT: 30,
    ID_FACEBOOK_BUFF_MEM_GROUP_NO_AVATAR: 31,
    ID_SHARE_STREAM: 32,
    ID_BOT_EXTENSION: 33,
    ID_POST_GROUP: 34,
    ID_SUB_TAY: 35,
    ID_LIKE_FANPAGE_TAY: 36,
    ID_LIKE_POST_TAY: 37,

    ID_TIKTOK_LIKE: 16,
    ID_TIKTOK_COMMENT: 17,
    // ID_TIKTOK_VIEW: 18,
    ID_TIKTOK_FOLLOW: 19,

    ID_INSTAGRAM_REACTION_POST: 6,
    ID_INSTAGRAM_FOLLOW_PROFILE: 7,
    ID_INSTAGRAM_COMMENT_POST: 8,

    ID_LIKE_POST_VIP_CLONE: 9,
    ID_LIKE_POST_VIP_MONTH: 10,
    ID_LIKE_POST_VIP_QUANTITY: 11,
    ID_LIKE_POST_VIP_REACTION: 12,
    ID_COMMENT_POST_VIP: 13,

    ID_BUFF_VIP_LIKE_INSTAGRAM: 25,
    ID_BUFF_VIP_COMMENT_INSTAGRAM: 26,

    ID_FACEBOOK_UVIEW: 20,
    ID_YOUTUBE_UVIEW: 21,
    ID_TIKTOK_UVIEW: 22,

    ID_TELEGRAM_MEM_GROUP: 40,

    ID_YOUTUBE_LIKE : 38,
    ID_YOUTUBE_4K_VIEW : 41,
    ID_FACEBOOK_COMMENT_IMAGE : 42,
    ID_TIKTOK_VIP_LIKE : 44,
};

export const defaultFbPost = {
    SHARE: {
        amount: 100
    },
    LIKE: {
        amount: 100
    },
    COMMENT: {
        amount: 0
    },
    LIKE_FANPAGE: {
        amount: 100
    },
    FOLLOW: {
        amount: 100
    },
    INSTA_LIKE: {
        amount: 100
    },
    INSTA_FOLLOW: {
        amount: 100
    },
    INSTA_COMMENT: {
        amount: 0
    },
    STREAM: {
        price: 100,
        amount: 50,
        time: 60
    },
    REVIEW: {
        amount: 3000,
    },

    TIKTOK_LIKE: {
        amount: 100
    },
    TIKTOK_FOLLOW: {
        amount: 100
    },
    TIKTOK_COMMENT: {
        amount: 100
    },
    TIKTOK_VIEW: {
        amount: 1000
    },
    GROUP: {
        amount: 100
    },
    LIKE_COMMENT: {
        amount: 100
    },
    FACEBOOK_VIEW: {
        amount: 100
    },
    YOUTUBE_VIEW: {
        amount: 1000
    },
};
export const CUSTOMER_CONFIG_KEY = {
    FAV_ICON: 'key_cp_logo',
    WEB_TITLE: 'key_cp_app_name'
};

export const STATUS_BOT_ORDER = {
    ACTIVE: 1,
    INACTIVE: 2,
    EXPIRED: 3,
    COOKIE_EXPIRED: 4,
    IP_EXPIRED: 5,
};

export const YOUTUBE_MAINTAIN = {
    VIEW_MAINTAIN: 1,
    SUB_MAINTAIN: 2,
    BOTH_MAINTAIN: 3
};